import type { ComponentProps } from "react";
import { ImportCheckbox } from "./ImportCheckbox";
import styles from "./ChipCheckbox.module.css";

type ChipCheckboxProps = Omit<ComponentProps<"input">, "type" | "ref" | "children"> & {
  label: string;
};

/** A pill holding a checkbox and its label; the whole pill is the click target and the label names the checkbox. */
export function ChipCheckbox({ label, className, disabled, ...inputProps }: ChipCheckboxProps) {
  const classes = [styles.chip, disabled ? styles.disabled : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={classes}>
      <ImportCheckbox {...inputProps} disabled={disabled} />
      <span className={styles.label}>{label}</span>
    </label>
  );
}
